import { Row } from "reactstrap";
import DashboardGroup, { DashboardGroupProps } from "./DashboardGroup";
import { IsCauwUser, IsOrganizationUser } from "../../utility/helpers/claimHelper";

const groups: DashboardGroupProps[] = [
  {
    title: "Campaign Reports",
    items: [
      {
        title: "Campaign Contributions Report",
        subtitle: "View Campaign Contributions Report",
        href: "/reports-page/report-campaign-contributions",
        },
       {
           title: "Campaign Designations Report",
           subtitle: "View Campaign Designations Report",
           href: "/reports-page/report-campaign-designations",
      },
    ],
        isDisplayed: IsCauwUser() ? true : false
  },
  {
    title: "Exxon Reports",
    items: [
      {
       title: "Campaign Contributions Report",
        subtitle: "View Campaign Contributions Report",
        href: "/reports-page/report-campaign-contributions",
      },
    ],
      isDisplayed: IsOrganizationUser() ? true : false
  },
];

const ReportsDashboard = () => {
  return (
    <div style={{ height: "auto" }}>
      <Row>
        {groups.map((item: DashboardGroupProps, index: number) => (
          <div key={index}>
            {(item.isDisplayed || item.isDisplayed === undefined) && (
              <DashboardGroup
                title={item.title}
                items={item.items}
                isDisplayed={item.isDisplayed}
              />
            )}
          </div>
        ))}
      </Row>
    </div>
  );
};

export default ReportsDashboard;
